module.exports = __webpack_public_path__ + "static/media/Savings.6dbd53f8.png";